import { useEffect, useState } from 'react';
import { energyService } from '../services';

export default function useEnergy() {
  const [userEnergy, setUserEnergy] = useState(500);
  const [referralCode, setReferralCode] = useState('');

  useEffect(() => {
    const fetchUserEnergy = async () => {
      try {
        const data = await energyService.getEnergy();
        if (data.success) {
          setUserEnergy(data.energy);
          setReferralCode(data.referral_code);
        }
      } catch (error) {
        console.error('Erro ao buscar energia:', error);
      }
    };

    fetchUserEnergy();

    const handleEnergyUpdate = (event) => {
      if (event.detail && event.detail.energy !== undefined) {
        setUserEnergy(event.detail.energy);
      }
    };

    window.addEventListener('energyUpdated', handleEnergyUpdate);
    return () => window.removeEventListener('energyUpdated', handleEnergyUpdate);
  }, []);

  return {
    userEnergy,
    setUserEnergy,
    referralCode
  };
}
